<template>
  <div class="animated fadeIn">
    <basic-heading title="Laboratories" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list laboratory'">
      <template #gated-content>
        <laboratory-server-table />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import LaboratoryServerTable from "@/components/lab/laboratory/LaboratoryServerTable";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "LaboratoryIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    LaboratoryServerTable,
    PermissionAlertGate,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/laboratory/add",
            title: "Add laboratory",
            variant: "success",
            permission: this.checkPermission("add laboratory"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
